import type { MaturityReadSide } from "../types"

export const getMaturityLabel = (maturity: MaturityReadSide) => {
  switch (maturity) {
    case "60":
      return "5 anni"
    case "96":
      return "8 anni"
    default:
      return ""
  }
}
